import LinkHeader from "http-link-header";
import {AxiosResponse} from "axios";

const LINK_HEADER = 'link';

export function extractFirstHeaderLink(response: AxiosResponse<any>, rel: string) {
    const links = extractHeaderLinks(response, rel);
    if (links) {
        return links[0];
    }
    return null;
}

export function extractHeaderLinks(response: AxiosResponse<any>, rel: string) {
    if (response.headers[LINK_HEADER]) {
        const links = LinkHeader.parse(response.headers[LINK_HEADER]);
        if (links) {
            return links.get('rel', rel)
        }
    }
    return []
}
